import {
  LucideFunctionSquare,
  HelpCircle,
  Zap,
  Clock,
  ArrowRightCircle,
  Database,
  CheckCircle2,
  Sparkles,
  Headphones,
  Link2,
  Play,
  MessageSquare,
  GitFork
} from 'lucide-react';

export const TYPE_CONFIG = {
  start: { 
    icon: Play, 
    color: 'bg-emerald-50 text-emerald-600', 
    label: 'START',
    description: 'The starting point of your conversation flow.'
  },
  message: { 
    icon: MessageSquare, 
    color: 'bg-blue-50 text-blue-600', 
    label: 'MESSAGE',
    description: 'Send a text or image message to the user.'
  },
  condition: { 
    icon: GitFork, 
    color: 'bg-purple-50 text-purple-600', 
    label: 'CONDITION',
    description: 'Branch the flow based on logic or user data.'
  },
  input: { 
    icon: HelpCircle, 
    color: 'bg-amber-50 text-amber-600', 
    label: 'INPUT',
    description: 'Pause and wait for the user to provide information.'
  },
  action: { 
    icon: Zap, 
    color: 'bg-indigo-50 text-indigo-600', 
    label: 'WEBHOOK',
    description: 'Perform an external API call or background task.'
  },
  webhook_result: {
    icon: CheckCircle2,
    color: 'bg-emerald-50 text-emerald-600',
    label: 'SUCCESS',
    description: 'Executed when the webhook call succeeds.'
  },
  delay: { 
    icon: Clock, 
    color: 'bg-slate-50 text-slate-600', 
    label: 'DELAY',
    description: 'Add a timed pause before the next step.'
  },
  goto: { 
    icon: ArrowRightCircle, 
    color: 'bg-rose-50 text-rose-600', 
    label: 'GOTO',
    description: 'Jump to a specific node anywhere in the flow.'
  },
  attribute: {
    icon: Database,
    color: 'bg-sky-50 text-sky-600',
    label: 'SET ATTRIBUTE',
    description: 'Set a value for a specific user attribute or variable.'
  },
  ai_agent: {
    icon: Sparkles,
    color: 'bg-violet-50 text-violet-600',
    label: 'AI NODE',
    description: 'Send prompts to an AI provider and use the response in your flow.'
  },
  function: { 
    icon: LucideFunctionSquare,
    color: 'bg-cyan-50 text-cyan-600', 
    label: 'FUNCTION',
    description: 'Execute custom JavaScript code with flow context.'
  },
  escalate: {
    icon: Headphones,
    color: 'bg-orange-50 text-orange-600',
    label: 'ESCALATE',
    description: 'Escalate the chat session to a live human agent.'
  },
  integration: {
    icon: Link2,
    color: 'bg-teal-50 text-teal-600',
    label: 'INTEGRATION',
    description: 'Trigger actions on active integrations (e.g. Freshchat handoff).'
  },
};
